import React from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { Popup } from 'react-map-gl'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import ApartmentCard from '../ApartmentCardVersion2'

import IconButton from '../../atoms/Button/IconButton'
import Icon from '../../atoms/Icon'
import Container from '../../atoms/Map/ApartmentCardPopup'

const defaultProps = {
  dynamicPosition: false,
  closeButton: false,
  closeOnClick: false,
  anchor: 'bottom',
  offsetTop: 21,
  offsetLeft: 8,
}

export default ({ apartment, ...props }) => (
  <Container>
    <OutsideClickHandler onOutsideClick={props.onClose}>
      <Popup
        latitude={apartment.coordinates.lat}
        longitude={apartment.coordinates.lng}
        {...defaultProps}
        {...props}
      >
        <IconButton onClick={props.onClose}>
          <Icon icon={faTimes} fixedWidth />
        </IconButton>
        <ApartmentCard {...apartment} />
      </Popup>
    </OutsideClickHandler>
  </Container>
)
